import styled from 'styled-components';

import { Divider, Skeleton } from 'opencare-crown';

import { AutocompleteDropdown } from '../Autocomplete/Autocomplete';

export const SelectSkeleton = styled(Skeleton)`
  && {
    width: 100%;
    margin: ${(props) => props.margin};
    .ant-skeleton-title {
      height: 34px;
    }
  }
`;

export const DropdownDivider = styled(Divider)`
  && {
    margin: 8px 0;
  }
`;

// This allows us to use the new Autocomplete in places where the form label
// is absolutely positioned.
export const LegacyStyledAutocomplete = styled(AutocompleteDropdown)`
  .autocomplete-input-wrapper {
    padding-top: 24px;
    box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.1);
  }
`;
